<template>
  <v-container
    fundamental
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
        lg12>
        <material-card
          title="查詢需求單"
          class="card-padding v-card__first"
          color="general">
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout
                wrap
                align-center>
                <v-flex
                  xs12
                  lg3>
                  <v-select
                    v-model="dateType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="dateTypeItems"
                    label="日期條件"
                  />
                </v-flex>
                <v-flex
                  xs12
                  lg3>
                  <v-menu
                    v-model="startMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px">
                    <v-text-field
                      slot="activator"
                      v-model="dateStart"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      label="開始日期"
                      prepend-icon="event"
                      readonly
                      clearable
                    />
                    <v-date-picker
                      v-model="dateStart"
                      :color="theme==='dark'?'danger':'general'"
                      no-title
                      scrollable
                      @input="startMenu = false"
                    />
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  lg3>
                  <v-menu
                    v-model="endMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px">
                    <v-text-field
                      slot="activator"
                      v-model="dateEnd"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      label="結束日期"
                      prepend-icon="event"
                      readonly
                      clearable
                    />
                    <v-date-picker
                      v-model="dateEnd"
                      :color="theme==='dark'?'danger':'general'"
                      no-title
                      scrollable
                      @input="endMenu = false"
                    />
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  lg3
                  text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSearch">
                    <v-icon class="mr-2">mdi-magnify</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        xs12
        lg12>
        <material-card
          id="checkTable"
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          title="需求單列表"
          color="deep-orange"
          class="card-mix d-table-t0 no-data-left"
          style="margin-top: 30px!important;">
          <v-data-table
            :headers="headers"
            :items="rows"
            :pagination.sync="pagination"
            :total-items="totalCount"
            :rows-per-page-items="[10, 20, 50]"
            class="height-row-3 table-align-left"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <tr>
                <td>{{ item.ticketNo }}<div class="caption grey--text">{{ item.version }}</div></td>
                <td>
                  <v-chip
                    v-if="item.pendingForMe === 1"
                    color="red"
                    text-color="white"
                    small>待處理</v-chip>
                  {{ item.title }}
                </td>
                <td>{{ item.requesterName }}</td>
                <td>{{ item.reqDate }}</td>
                <td>{{ item.actualStartDate }}</td>
                <td>{{ item.actualEndDate }}</td>
                <td>{{ item.developers }}</td>
                <td>{{ item.reviewerName }}</td>
                <td>{{ item.remainingDays }}</td>
                <td>{{ item.statusName }}</td>
                <td>
                  <v-btn
                    small
                    flat
                    color="general"
                    @click="openDetail(item)">明細</v-btn>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <span>沒有符合的需求單</span>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'RequirementTicket',
  data () {
    return {
      Loading,
      loadingView: false,
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      ready: false,
      dateType: 'REQ',
      dateStart: '',
      dateEnd: '',
      startMenu: false,
      endMenu: false,
      dateTypeItems: [
        { text: '需求日期', value: 'REQ' },
        { text: '開發日期（實際）', value: 'DEV' }
      ],
      rows: [],
      totalCount: 0,
      pagination: { page: 1, rowsPerPage: 10, sortBy: '', descending: true },
      headers: [
        { text: '需求單號', value: 'ticketNo', sortable: true },
        { text: '標題', value: 'title', sortable: true },
        { text: '提出人', value: 'requesterName', sortable: false },
        { text: '需求日期', value: 'reqDate', sortable: true },
        { text: '實際開始', value: 'actualStartDate', sortable: false },
        { text: '實際結束', value: 'actualEndDate', sortable: false },
        { text: '開發人員', value: 'developers', sortable: false },
        { text: '審核人員', value: 'reviewerName', sortable: false },
        { text: '剩餘天數', value: 'remainingDays', sortable: false },
        { text: '狀態', value: 'status', sortable: true },
        { text: '操作', value: 'operation', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink'])
  },
  watch: {
    pagination: {
      handler () {
        if (this.ready) this.queryList()
      },
      deep: true
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/system/requirementTicket')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          this.ready = true
          this.queryList()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(() => {
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    toast (msg, ok) {
      this.snackbarMsg = msg
      this.snackbarColor = ok ? 'green' : 'red'
      this.snackbar = true
    },
    doSearch () {
      if (this.pagination.page !== 1) this.pagination.page = 1
      else this.queryList()
    },
    queryList () {
      this.loadingView = true
      const body = {
        pageNum: this.pagination.page,
        pageRows: this.pagination.rowsPerPage,
        sortColumn: this.pagination.sortBy || '',
        sortType: this.pagination.descending ? 'desc' : 'asc',
        dateType: this.dateType,
        dateStart: this.dateStart || '',
        dateEnd: this.dateEnd || ''
      }
      this.$http.post('/api/system/req/queryTicketList', body).then(res => res.data)
        .then(res => {
          this.loadingView = false
          if (res.status !== 'success') {
            this.toast(res.errMsg || '查詢失敗')
            this.rows = []
            this.totalCount = 0
            return
          }
          this.rows = res.data.dataList || []
          this.totalCount = res.data.totalCount || 0
        })
        .catch(() => {
          this.loadingView = false
          this.toast('查詢失敗')
        })
    },
    openDetail (item) {
      this.$router.push({ path: '/system/requirementTicketForm', query: { ticketNo: item.ticketNo, version: item.version } })
    }
  }
}
</script>
